import { combineReducers } from '@reduxjs/toolkit';
import { emptySplitApi } from './emptyApi';

// Import slices
import userContextSlice from '../common/slices/userContextSlice';
import impersonationSlice from '../common/slices/impersonationSlice';
import contentSharingSlice from '../areas/content-sharing/contentSharingSlice';
import featureSlice from '../common/slices/featureSlice';
import cultureHubRootSlice from '../areas/culture-hub/slices/cultureHubRootSlice';
import cultureHubBioSlice from '../areas/culture-hub/slices/cultureHubBioSlice';
import cultureHubAnalyticsSlice from '../areas/culture-hub/slices/cultureHubAnalyticsSlice';
import cultureHubInterventionsSlice from '../areas/culture-hub/slices/cultureHubInterventionsSlice';
import repositoryManagementSlice from '../areas/settings/repository-management/repositoryManagementSlice';

// Import legacy reducers
import errors from './reducers/errors';
import signupSteps from './reducers/signup_steps';
import employee_permission from './reducers/employee_permission';
import employee_roles from './reducers/employee_roles';
import fileupload from './reducers/fileupload';
import audit from './reducers/audit';
import member_filters from './reducers/member_filters';

/**
 * The application's reducer map.
 *
 * Lives in its own module so tests can build a store with the real state shape
 * by importing this file alone. Importing `./store` instead would execute that
 * module's side effects (persistStore, setupListeners, configureUserStorage)
 * and create a second live store per test file.
 */
export const rootReducer = combineReducers({
  // Legacy reducers
  errors,
  employee_permission,
  employee_roles,
  fileupload,
  signupSteps,
  audit,
  member_filters,

  // Slices
  userContext: userContextSlice.reducer,
  impersonation: impersonationSlice.reducer,
  contentSharing: contentSharingSlice.reducer,
  features: featureSlice.reducer,
  cultureHubRoot: cultureHubRootSlice.reducer,
  cultureHubBio: cultureHubBioSlice.reducer,
  cultureHubAnalytics: cultureHubAnalyticsSlice.reducer,
  cultureHubInterventions: cultureHubInterventionsSlice.reducer,
  repositoryManagement: repositoryManagementSlice.reducer,

  // RTK Query API - all APIs extend from emptySplitApi
  [emptySplitApi.reducerPath]: emptySplitApi.reducer,
});

export default rootReducer;
